<app-template-text (onblur)="onblur.emit()" [counter]="counter" [disabled]="disabled" [characters]="characters" [value]="value" [control]="control" [label]="label" />
